/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {
    "use strict";

    export class ContractsDashboardController {
        public static $inject : string[] = [
            '$dealerwareSolrSearchContractCollection',
            '$timeout',
            '$state'
        ];

        constructor(public $dealerwareSolrSearchContractCollection: any,
                    public $timeout: any,
                    public $state: any) {}

        public goToContractDetails(record: any) : void {
            this.$state.go('shortcuts.contractDetails', { contractId: record.data.id });
        }
    }

    getDealerwareWebContentModule().controller('ContractsDashboardController', ContractsDashboardController);
}
